import React from 'react';
import { makeStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import TickIcon from '../svg/TickIcon';
import RightArrowIcon from '../svg/RightArrowIcon';
import palette from '../theme/palette';
import CloseIcon from '../svg/CloseIcon';

const useStyles = makeStyles({
  container: {
    marginTop: 10,
    display: 'flex',
    padding: 10,
    border: '1px solid rgba(0, 0, 0, 0.08)',
    backgroundColor: 'white',
    borderRadius: 8,
    alignItems: 'center',
    cursor: 'pointer'
  },
  rightIcon: {
    marginLeft: 'auto',
    marginRight: 10
  },
  leftIconContainer: {
    backgroundColor: palette.secondary.lighter,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // padding: 15,
    borderRadius: 6,
    marginRight: 15,
    width: 60,
    height: 60
  },
  titleStyle: {
    fontSize: 16
  },
  subTitleStyle: {
    fontSize: 13,
    color: palette.grey[500]
  },
  testStarted: {
    fontSize: 13,
    color: 'green'
  },
  markedDone: {
    color: 'green',
    fontSize: 13
  },
  markedNotDone: {
    color: 'red',
    fontSize: 13
  }
});

export default function NameAndChangeToScreenCard({
  title,
  isTestStarted = false,
  subTitle,
  icon,
  onClick,
  isDisplayMark = false,
  markedDone,
  isStudent = false,
  testMark,
  totalMark
}) {
  const classes = useStyles();
  return (
    <div className={classes.container} role="presentation" onClick={() => onClick()}>
      <div className={classes.leftIconContainer}>{icon}</div>
      <div>
        <p className={classes.titleStyle}>{title}</p>
        {isTestStarted && <p className={classes.testStarted}>Test Started</p>}
        {subTitle && !isTestStarted && <p className={classes.subTitleStyle}>{subTitle}</p>}
        {isDisplayMark && isStudent && markedDone && (
          <p className={classes.markedDone}>
            <TickIcon color="green" /> Marked as Done - {testMark}/{totalMark}
          </p>
        )}
        {isDisplayMark && isStudent && !markedDone && (
          <p className={classes.markedNotDone}>
            <CloseIcon color="red" /> Marked not Done
          </p>
        )}
      </div>
      <div className={classes.rightIcon}>
        <RightArrowIcon />
      </div>
    </div>
  );
}

NameAndChangeToScreenCard.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  icon: PropTypes.any,
  onClick: PropTypes.func,
  isTestStarted: PropTypes.bool,
  markedDone: PropTypes.bool,
  isStudent: PropTypes.bool,
  testMark: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  totalMark: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isDisplayMark: PropTypes.bool
};
